//
import { getAuthHeaders } from './authActions'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const getCheckInById = async (id) => {
	const res = await fetch(`${BASE_URL}/api/checkIns/${id}`, {
		method: 'GET',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
	})

	if (!res.ok) {
		throw new Error('Check-In not found')
	}

	return res.json()
}

export const searchCheckIns = async (experienceSlug, query) => {
	const res = await fetch(
		`${BASE_URL}/api/checkIns/experience/${experienceSlug}/search?q=${encodeURIComponent(
			query
		)}`,
		{
			method: 'GET',
			headers: {
				...getAuthHeaders(),
			},
		}
	)

	if (!res.ok) {
		throw new Error('Search failed')
	}

	return res.json()
}

export const updateCheckIn = async (id, data) => {
	const res = await fetch(`${BASE_URL}/api/checkIns/${id}`, {
		method: 'PATCH',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	})

	if (!res.ok) {
		throw new Error('Update failed')
	}

	return res.json()
}

export const getExperienceCheckIns = async (experienceSlug) => {
	const res = await fetch(
		`${BASE_URL}/api/checkIns/experience/${experienceSlug}`,
		{
			headers: { ...getAuthHeaders() },
		}
	)
	if (!res.ok) throw new Error('Failed to fetch check-ins')
	return res.json()
}

export const uploadExperienceCheckIns = async (experienceSlug, checkIns) => {
	const res = await fetch(
		`${BASE_URL}/api/checkIns/experience/${experienceSlug}/upload`,
		{
			method: 'POST',
			headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
			body: JSON.stringify(checkIns),
		}
	)

	if (!res.ok) throw new Error('Failed to upload check-ins')
	return res.json()
}
export const createCheckIn = async (experienceSlug, data) => {
	const res = await fetch(
		`${BASE_URL}/api/checkIns/experience/${experienceSlug}/upload`,
		{
			method: 'POST',
			headers: {
				...getAuthHeaders(),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify([data]),
		}
	)
	if (!res.ok) throw new Error('Failed to create check-in')
	return res.json()
}

export const deleteCheckIn = async (id) => {
	const res = await fetch(`${BASE_URL}/api/checkIns/${id}`, {
		method: 'DELETE',
		headers: {
			...getAuthHeaders(),
		},
	})

	if (!res.ok) {
		throw new Error('Delete failed')
	}

	return res.json()
}
